<template>
  <div id="careful-wish-app">
    <div id="query">
      <form action="">
        <input v-model="query"
          type="text"
          name=""
          id=""
          ref="wish"
          placeholder="wish for something..."
          maxlength="25"
          :disabled="searching"
          autofocus>
        <input type="submit" value="Wish" :disabled="searching" @click.capture.prevent="wish">
      </form>
    </div>

    <div v-if="searching" id="searching">
      Searching...
    </div>

    <div v-if="lastWish.length > 0" id="result">
      <div v-if="gotError" class="wish">
        <span class="error">Something bad happened. If this error persists, please contact the author of this puzzle.</span></div>
      <div v-else>
        <div v-if="lastWishNotFound" class="wish">
          <span class="wish-query">{{lastWish}}</span> not found!</div>
        <div v-else>
          <div class="wish">Here is your <span class="wish-query">{{lastWish}}</span>:</div>
          <div class="img"><img :src="img"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CarefulWishApp',
  data() {
    return {
      query: '',
      lastWish: '',
      img: '',
      searching: false,
      lastWishNotFound: false,
      gotError: false,
    }
  },

  computed: {
    queryClean: function () {
      return this.query.toLowerCase().replace(/[^a-z ]/gi, '').trim()
    },
  },

  methods: {

    reset: function () {
      this.lastWish = this.query
      this.query = ''
      this.searching = false
      this.$refs.wish.disabled = false
      this.$refs.wish.focus()
    },

    makeWish: async function (query) {
      let queryEncoded = encodeURI(query)
      let url = `https://careful-wish.humfuzz.com/api/wish?wish=${queryEncoded}`
      let options = {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        }
      }
    
      return fetch(url, options)
        .then(response => {
          return response.json()
        })
        .catch(err => {
          this.gotError = true
          return false
        })
    
    },

    wish: async function () { 

      this.searching = true

      if (this.queryClean === "") {
        this.reset()
        this.lastWish = ''
        this.gotError = false
        return
      }

      let img = await this.makeWish(this.queryClean)

      if (img === "not found") {
        this.lastWishNotFound = true
      } else if (img) {
        this.img = img
        this.lastWishNotFound = false
        this.gotError = false
      } else {
        this.lastWishNotFound = true
      }
      this.reset()

    },
  },

}
</script>

<style lang="scss">
#careful-wish-app {
    text-align: center;
    font-size: 1.3rem;
    margin-top:60px;
    background-color: #ffffff;
    /* blend from translucent to pure white */
    box-shadow: 0px 0px 15px 15px #ffffffff;
}

#careful-wish-app input {
    font-family: inherit;
    font-size: 1.3rem;
    text-align: center;
    color: #043d36;
    
    height: 50px;
    box-sizing: border-box;
    
    margin: 3px 0;
    border-radius: 10px 0 0 10px;
    border: 1px solid #779692;
    border-right: 0px;
    background-color: #d9e7e5;

    outline: none;
}

#careful-wish-app input:disabled {
    color: #3c6964;
    border: 1px solid #a6b4b2;
    border-right: 0px;
    background-color: #b5c7c3;
}

#careful-wish-app input:focus {
    box-shadow: 0 0 3px 1px inset #076356;
}

#careful-wish-app input::placeholder {
    color: #779692;
}

#careful-wish-app input[type=submit] {
    background-color: #068f7d;
    border: 0px;
    color: #eeeeee;
    border-radius: 0 10px 10px 0;
}

#careful-wish-app input[type=submit]:disabled {
    background-color: #479087;
    color: #b5c7c3;
}

#careful-wish-app input[type=submit]:focus {
    box-shadow: none;
}


#careful-wish-app input[type=submit]:hover {
    background-color: #10a591;
}

#careful-wish-app #result {
    padding: 40px;
}

#careful-wish-app .wish-query {
    font-weight: bold;
    text-transform: uppercase;
    color: #076356;
}

#careful-wish-app .error {
    font-weight: bold;
    font-style: italic;
    color: #92173c;
}

</style>
